module.exports = __webpack_public_path__ + "static/img/North-Fitzroy-Arms.1d191f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/North-Fitzroy-Arms.jpg
// module id = HDo8
// module chunks = 0